import React, { useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { UserAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom'
import '../login-signup/login-signup.css';

const PasswordReset = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const { resetPassword } = UserAuth();
    const { isDarkMode, themeClass, toggleTheme } = useTheme();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        try {
            await resetPassword(email);
            setMessage('Check your inbox for further instructions');
        } catch (error) {
            setError('Failed to reset password');
        }
    };

    return (
        <div className={`signup-container ${themeClass}`}>
            <div className={`topButtons ${themeClass}`}>
                {/* Toggle de Tema */}
                <div className="header-left">
                    <div className="theme-toggle">
                        <span className="colorIconToggle">☼</span>
                        <label className="toggle-switch">
                            <input
                                type="checkbox"
                                checked={isDarkMode}
                                onChange={toggleTheme}
                                className="toggle-input"
                            />
                            <span className={`toggle-slider ${themeClass}`}>
                                <span className={`toggle-knob ${themeClass}`} />
                            </span>
                        </label>
                        <span className="colorIconToggle">☽</span>
                    </div>
                </div>
                <Link to='/login' className={`back-button ${themeClass}`}>
                    ⟨ &nbsp;&nbsp; Regresar
                </Link>
            </div>
            <div className="signupcontainer">
                <form onSubmit={handleSubmit} className="signup-form">
                    <h1 className={`signup-title ${themeClass}`}> Reset Password</h1>
                    {error && <div className="error-message">{error}</div>}
                    {message && <div className="success">{message}</div>}
                    <input
                        className={`input-field ${themeClass}`}
                        type='email'
                        placeholder='Enter your email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <div className='sigup-b'>
                        <button className={`color-button ${themeClass}`} type='submit'>Reset Password</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PasswordReset;
